import script from "./QuestionManagementCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionManagementCreate.vue?vue&type=script&setup=true&lang=js"

import "./QuestionManagementCreate.vue?vue&type=style&index=0&id=3e1ee259&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Stage-Leadership_Admin_Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e1ee259"]])

export default __exports__